<template>
    <app-layout>
      <Head title="Scheduled"/>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Past Due Payment
            </h2>
        </template>


        <PanelSlot
            title="Please Update Payment Method"
            :subtitle="'Required by ' + cancellationDate"
            :topBorder="false"
        >
            <div class="text-16px">
                <div>
                    <div class="mb-4">
                        We were unable to charge your payment method for your TextSpot subscription.
                    </div>
                    <div class="font-bold mb-4">
                        Please update your payment information to continue sending messages with TextSpot.
                    </div>
                    <div>
                        Make a payment by {{ cancellationDate }} or your account will lose your phone number and carrier registration status.
                    </div>

                </div>
            </div>
            <div>
                <a :href="route('billing.portal')" class="w-full text-center">
                    <jet-button secondary class="mt-6  mr-8">
                        Update Payment Method
                    </jet-button>
                </a>
            </div>
        </PanelSlot>

    </app-layout>
</template>

<script>
import axios from "axios";
import PanelSlot from "@/components/PanelSlot";
import moment from 'moment';
export default {
    components: {
        PanelSlot
   },
    data() {
        return {
        };
    },
    computed: {
        cancellationDate() {
            return moment(this.$page.props.cancellation_date).format('MMMM D, YYYY');
        }
    },
    methods: {
    }
};
</script>
